import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Quote, Star } from "lucide-react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function TestimonialsPage() {
  const { t } = useLanguage();
  return (
    <div data-testid="testimonials-page">
      <section className="py-24">
        <div className="container-pad max-w-3xl">
          <div className="overline">{t.testimonials.overline}</div>
          <h1 className="mt-4 font-serif text-5xl sm:text-6xl leading-[1] text-brand-primary">
            {t.testimonials.title}
          </h1>
        </div>

        <div className="container-pad mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {t.testimonials.items.map((item, idx) => (
            <article
              key={`${item.name}-${idx}`}
              data-testid={`testimonial-card-${idx}`}
              className={`relative rounded-xl border border-brand-line p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-md ${
                idx % 3 === 1 ? "bg-brand-primary text-brand-surface" : "bg-brand-surface"
              }`}
            >
              <Quote
                className={idx % 3 === 1 ? "text-brand-accent" : "text-brand-accent"}
                size={24}
              />
              <div
                className={`mt-4 flex items-center gap-1 ${
                  idx % 3 === 1 ? "text-brand-accent" : "text-brand-accent"
                }`}
              >
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={14} fill="currentColor" stroke="none" />
                ))}
              </div>
              <p
                className={`mt-5 text-[15px] leading-relaxed ${
                  idx % 3 === 1 ? "text-brand-surface/85" : "text-brand-text/80"
                }`}
              >
                {`"${item.text}"`}
              </p>
              <div
                className={`mt-6 pt-5 border-t ${
                  idx % 3 === 1 ? "border-brand-surface/20" : "border-brand-line"
                }`}
              >
                <div
                  className={`font-serif text-lg ${
                    idx % 3 === 1 ? "text-brand-surface" : "text-brand-primary"
                  }`}
                >
                  {item.name}
                </div>
                <div
                  className={`text-xs uppercase tracking-widest mt-1 ${
                    idx % 3 === 1 ? "text-brand-surface/60" : "text-brand-muteText"
                  }`}
                >
                  {item.role}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="container-pad mt-20 text-center">
          <Link
            to="/contact"
            data-testid="testimonials-cta"
            className="inline-flex items-center gap-2 rounded-full bg-brand-primary text-brand-surface px-8 py-4 text-sm font-semibold hover:bg-brand-secondary transition-colors"
          >
            {t.nav.cta}
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
